import { baseUrl, envVar } from '../../config/baseUrl';
import OpenReplay from '@openreplay/tracker';
let Spreedly = window.Spreedly;

export const configureBrowserInfo = async () => {
    // Choose a browser size for your application. This will be the size of the challenge
    // iframe that will be presented to a user. *note* If you're creating a modal, you
    // should make the surrounding DOM node a little larger than the option selected
    // below.
    //
    // '01' - 250px x 400px
    // '02' - 390px x 300px
    // '03' - 500px x 600px
    // '04' - 600px x 400px
    // '05' - fullscreen
    var browser_size = '04';
    // The accept header from your server side rendered page. You'll need to inject it into the page. Below is an example.
    var acceptHeader = 'text/html,application/xhtml+xml,application/xml;q=0.9,*/*;q=0.8'
    // The request should include the browser data collected by using `Spreedly.ThreeDS.serialize().
    let browser_info = await Spreedly.ThreeDS.serialize(
        browser_size,
        acceptHeader
    );
    return browser_info;
}

export const initiateOpenReplay = (order_id) => {
    let tracker;
    if (order_id) {
        tracker = new OpenReplay({
            projectKey: `${envVar.openreplayProjectKey}`,
            ingestPoint: `${baseUrl.openreplayIngestPoint}`,
            // __DISABLE_SECURE_MODE: true
        });
        tracker.start({
            userID: `${order_id}`
        });
    }
    return () => {
        if (tracker) {
            tracker.stop();
        }
    };
};

export const spreedlyLifecycleHandler = async (token) => {
    console.log('inside spreedlyLifecycleHandler');
    let lifecycle = await new Spreedly.ThreeDS.Lifecycle({
        environmentKey: envVar.spreedlyEnvironmentKey,
        // The DOM node that you'd like to inject hidden iframes
        hiddenIframeLocation: 'deviceFingerprint',
        // The DOM node that you'd like to inject the challenge flow
        challengeIframeLocation: 'challengeContainer',
        // The token for the transaction - used to poll for state
        transactionToken: token,
        challengeIframeClasses: 'fit-to-modal mars-color-border'
        // The css classes that you'd like to apply to the challenge iframe.
        //
        // Note: This is where you'll change the height and width of the challenge
        //       iframe. You'll need to match the height and width option that you
        //       selected when collecting browser data with `Spreedly.ThreeDS.serialize`.
        //       For instance if you selected '04' for browserSize you'll need to have a
        //       CSS class that has width and height of 600px by 400px.
    });
    await lifecycle.start();
}

export const updateUI = (transactionData, isSuccess) => {
    // Clean up Spreedly's custom HTML elements
    console.log(transactionData);
    console.log(transactionData.context);
    if (document.querySelector("#challengeContainer")){
        document.querySelector("#challengeContainer").innerHTML = '';
        document.querySelector('#hiddenChallenge').className = "hidden";
        // document.querySelector('#payment-form-container').style.display = 'none';
    }

    if (isSuccess) {
        let returnUrl = localStorage.getItem("returnUrl");
        if (returnUrl) {
            console.log('returnUrl', returnUrl);
            window.location.replace(returnUrl);
        }
    } else {
        console.log(transactionData.context);
    }
}

const show3DSChallengeModal = (event) => {
    // For the complete example see step #7 ("Show your modal")
    // https://docs.spreedly.com/guides/3dsecure2/#integration
    console.log("Displaying modal");
    document.querySelector('#hiddenChallenge').className = "sp3ds2-modal";
}

Spreedly.on('3ds:status', (event) => {
    console.log(`event.action ${event.action}`);

    switch (event.action) {
        case "challenge":
            show3DSChallengeModal();
            break;
        case "succeeded":
            updateUI(event, true);
            break;
        case "finalization-timeout":
            // occurs 10-15 minutes after presenting a challenge without the transaction state changing.
            updateUI({ context: 'Time-Out. User did not authenticate within expected timeout.' }, false);
            break;
        case "error":
            updateUI(event, false);
            break;
        default:
            console.log(`Event ${{ event }} not handled`)
    }
});
